import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { SelectMoneda } from 'sharedComponents/select'

import { KeyEventUtil } from 'utils'

const MonedaFormGroup = ({ vOrigen, iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-modalavanz-tipoAfectacion', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='MONEDA' htmlFor='select-modalavanz-moneda' md={12} />
      <Col md={12}>
        <Field name='moneda'>
          {({ field }) => (
            <SelectMoneda
              {...field}
              id='select-modalavanz-moneda'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaFormGroup)
